/* eslint-disable react/prop-types */
import React from 'react'
import { CheckoutOutdated, CheckoutError } from '@pinflag/pinflag-ui-kit'

import { sendBotMessage } from './helpers/bot'
import companyApiInstance from './helpers/companyApiInstance'
import { getPinflagIdentity } from './helpers/utils'

const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' ||
  /ChunkLoadError|Loading chunk [\w-]+ failed/i.test(error?.message || '')

class ErrorBoundary extends React.Component {
  state = { hasError: false, isChunkError: false, logoUrl: null }

  static getDerivedStateFromError (error) {
    return { hasError: true, isChunkError: isChunkLoadError(error) }
  }

  componentDidCatch (error, info) {
    this.fetchCompanyLogo()
    if (isChunkLoadError(error)) return
    if (!info.componentStack.includes('localhost') && !info.componentStack.includes('ngrok')) {
      sendBotMessage(error.stack, document.location.href)
    }
  }

  fetchCompanyLogo = () => {
    const pinflagApiKey = getPinflagIdentity()
    if (!pinflagApiKey) return
    companyApiInstance(pinflagApiKey)
      .get('/company/personalization')
      .then((res) => this.setState({ logoUrl: res.data?.logoUrl }))
      .catch((err) => console.error(err))
  }

  render () {
    if (this.state.hasError) {
      const { logoUrl } = this.state
      if (this.state.isChunkError) return <CheckoutOutdated logoUrl={logoUrl} />
      return this.props.fallback || <CheckoutError logoUrl={logoUrl} />
    }
    return this.props.children
  }
}

export default ErrorBoundary
